import { useCallback, useState } from 'react';

export const useQRCode = (modalRef: React.RefObject<HTMLElement>) => {
  const [isLoading, setIsLoading] = useState(false);

  const renderModalToCanvas = useCallback(async () => {
    if (!modalRef.current) return null;
    setIsLoading(true);

    const { default: html2canvas } = await import('html2canvas');
    const canvas = await html2canvas(modalRef.current, {
      scale: 1,
      useCORS: true,
      backgroundColor: null,
      logging: false,
    });
    setIsLoading(false);
    return canvas;
  }, [modalRef]);

  const downloadModalAsPNG = useCallback(async () => {
    const canvas = await renderModalToCanvas();
    if (!canvas) return;

    const dataURL = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = dataURL;
    link.download = `qr-code-modal-${Date.now()}.png`;
    link.click();
  }, [renderModalToCanvas]);

  const copyModalToClipboard = useCallback(async () => {
    if (!document.hasFocus()) {
      window.focus();
      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    const canvas = await renderModalToCanvas();
    if (!canvas) return;

    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob((b) => resolve(b), 'image/png')
    );

    if (!blob) return;

    await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
  }, [renderModalToCanvas]);

  const printModal = useCallback(async () => {
    window.print();
  }, [modalRef]);

  return {
    printModal,
    downloadModalAsPNG,
    copyModalToClipboard,
    isLoading,
  };
};
